import type { Attachment } from '@/components/AttachmentPicker'
import { t } from '@/lib/i18n'

/**
 * 稿子的 `.shots`：作业图的横向缩略图条，末尾一个「＋图」。
 *
 * 横滑是这里唯一合理的形态（稿子也是）：一天可能有三四张黑板照，竖着排会把
 * 条目挤到屏幕外，而这些图是「瞄一眼对照着录」用的，不是主内容。
 *
 * 与看板的热力图不同 —— 那个横滑是**缺陷**（S3 里修掉了），因为热力图是要
 * 一眼看全的主内容；这里横滑是**选择**。
 */
export default function PhotoStrip({ photos, onAdd, onOpen, canWrite }: {
  photos: Attachment[]
  onAdd: () => void
  onOpen: (photo: Attachment) => void
  canWrite: boolean
}) {
  if (photos.length === 0) return null

  return (
    <div className="flex gap-2 mx-3 mt-3 pb-1 overflow-x-auto">
      {photos.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onOpen(p)}
          aria-label={t('homework.photo_view_aria')}
          className="shrink-0 w-[72px] h-[72px] rounded-ctl overflow-hidden bg-sunk active:opacity-80"
        >
          <img src={p.url} alt={t('homework.photo_alt')} className="w-full h-full object-cover" />
        </button>
      ))}
      {canWrite && (
        <button
          type="button"
          onClick={onAdd}
          aria-label={t('homework.photo_add_aria')}
          className="shrink-0 w-[72px] h-[72px] rounded-ctl border-[1.5px] border-dashed border-line bg-sunk text-muted text-xs font-bold active:bg-tint"
        >
          ＋{t('homework.photo_unit')}
        </button>
      )}
    </div>
  )
}
